import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

//获取问卷列表
export const getQuestionnaireList = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/question/v1/list', data);
};

//检查问卷是否可以参加
export const getQuestionnaireCheck = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/question/v1/check', params);
};

// 查询问卷配置
export const getQuestionnaireConfig = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/question/v1/config', params);
};

// 弹出一次
export const getQuestionnairePop = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/question/v1/pop', data);
};

//获取项目/赛事问卷列表
export const getQuestionnaireBusinessList = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/question/v1/business/page', data);
};

//我的问卷（独立/项目/赛事）
export const getQuestionnaireMyList = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/question/v1/page', data);
};